import { Language } from "@types";
import { Locale } from "kz-ui-sdk";

export const STORAGE_KEY = {
  ACCESS_TOKEN: "token",
  //only remember phone while onboard
  //if switch tab the onboarding phone is still be passed to login/register component
  ONBOARDING_PHONE: "onboarding-phone",
  LANGUAGE: "lng",
  LANGUAGE_MANUAL: "lng-manual",
  MODE: "mode",
  OTP_TIMEOUT_PREFIX: "pk-",
  MARKETING_DATA: "mktg-data",
  REF_CODE: "ref-code",
  APP_UPDATE_AVAILABLE: "app-update-available",
  LOGIN_METHOD: "login-method",
  LOGIN_CRED_ID: "login-id",
  LOGIN_CRED_SECRET: "login-secret",
  LOGIN_PHONE: "login-phone",
  MEMBER_SETTINGS: "member-settings",
  PUBLIC_CONTACT_BANNERS: "public-contact-banners",
  PUBLIC_GROUPED_CONTACT_ICON: "public-grouped-contact-icon",
  PRIVATE_CONTACT_BANNERS: "private-contact-banners",
  PRIVATE_GROUPED_CONTACT_ICON: "private-grouped-contact-icon",
  MEGA_SHARE_SEEN_GIVER_TX_ID: "mega-share-seen-giver-tx-id",
  SECRET_CODE_SEEN_GIVER_CODE: "secret-code-seen-giver-code",
  CASHBACK_PROMPT_COOLDOWN: "cashback-prompt-cooldown",
} as const;

export const LANGUAGES: Locale[] = [
  {
    code: Language.EN,
    displayName: "English",
    flagImage: {
      url: "/images/flags/flag-gb.svg",
    },
    sortPriority: 1,
  },
  {
    code: Language.TH,
    displayName: "ภาษาไทย",
    flagImage: {
      url: "/images/flags/flag-th.svg",
    },
    sortPriority: 2,
  },
  {
    code: Language.ID,
    displayName: "Bahasa Indonesia",
    flagImage: {
      url: "/images/flags/flag-id.svg",
    },
    sortPriority: 3,
  },
  {
    code: Language.BN,
    displayName: "বাংলা",
    flagImage: {
      url: "/images/flags/flag-bd.svg",
    },
    sortPriority: 4,
  },
  {
    code: Language.UR,
    displayName: "اردو",
    flagImage: {
      url: "/images/flags/flag-pk.svg",
    },
    sortPriority: 5,
  },
  {
    code: Language.TL,
    displayName: "Tagalog",
    flagImage: {
      url: "/images/flags/flag-ph.svg",
    },
    sortPriority: 6,
  },
  {
    code: Language.ES,
    displayName: "Español",
    flagImage: {
      url: "/images/flags/flag-mx.svg",
    },
    sortPriority: 7,
  },
  {
    code: Language.PT,
    displayName: "Português",
    flagImage: {
      url: "/images/flags/flag-br.svg",
    },
    sortPriority: 8,
  },
  {
    code: Language.HI,
    displayName: "हिन्दी",
    flagImage: {
      url: "/images/flags/flag-in.svg",
    },
    sortPriority: 9,
  },
  {
    code: Language.AR,
    displayName: "العربية",
    flagImage: {
      url: "/images/flags/flag-eg.svg",
    },
    sortPriority: 10,
  },
];

export const LANGUAGES_MAP: Record<Language, Locale> = {
  [Language.EN]: LANGUAGES[0],
  [Language.TH]: LANGUAGES[1],
  [Language.ID]: LANGUAGES[2],
  [Language.BN]: LANGUAGES[3],
  [Language.UR]: LANGUAGES[4],
  [Language.TL]: LANGUAGES[5],
  [Language.ES]: LANGUAGES[6],
  [Language.PT]: LANGUAGES[7],
  [Language.HI]: LANGUAGES[8],
  [Language.AR]: LANGUAGES[9],
};

export enum OnboardMode {
  LOGIN = "login",
  REGISTER = "register",
}

export const ACCESS_TOKEN_ENDPOINT = "/oauth/access_token";

export const DEFAULT_ERROR_MESSAGE = "an error occurred, please try again";

export const DEFAULT_CONNECTION_ERROR_MESSAGE = "something went wrong. please try again.";

export enum NotificationDrawerEnabledStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  LOADING = "loading",
}
